import { Component } from '@angular/core';

import { AnswerTypeComponent } from '../answer-type.component';

@Component({
    selector: 'answer-textbox',
    templateUrl: './answer-textbox.component.html',
    standalone: false
})
export class AnswerTextboxComponent extends AnswerTypeComponent {

}
